export default __webpack_public_path__ + "static/media/aboutDream.20603d3f.png";